








import Vue from 'vue';
import ChevronRight from '@/assets/img/icons/chevron-right.svg';

export default Vue.component('OptionWidget', {
  name: 'OptionWidget.vue',
  components: {
    ChevronRight,
  },
  props: {
    title: {
      type: String,
      default: 'Button Title',
    },
    action: {
      type: Function,
      default: () => {
        console.log('No action set.');
        return;
      },
    },
  },
});
